<template>
  <div id="login_div">
      <v-row :align="alignment" :justify="justify">
        <v-col cols="12">
          <p class="text-center">
            <img src="@/assets/logo_infilesign_white.png" alt="Prisma Sign">
          </p>
        </v-col>
        <v-col cols="12" md="4">
          <v-card class="elevation-12">
            <v-card-title>
              <span style="text-align: center !important; display: block; width: 100%">Confirma tu correo electrónico</span>
            </v-card-title>
            <v-card-text class="text-center">
              <p>Gracias por registrarse en Prisma Sign, la más novedosa, segura y versátil herramienta para firmar electrónicamente sus documentos con certeza legal.</p>
              <p>Para confirmar su correo necesita hacer click en el siguiente botón.</p>
              <v-btn 
                rounded 
                color="success"
                :loading="loading"
                class="mb-4"
                @click="activarCuenta">
                <v-icon dark>mdi-account-check-outline</v-icon>
                Confirmar mi cuenta
              </v-btn>
              <br />¡Bienvenido a Prisma Sign!
            </v-card-text>
            <v-card-actions>
              <v-btn text :to="{name: 'login'}" class="mr-4" color="info">Iniciar sesión</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
  </div>
</template>
<script>
    import axios from "axios";
    export default {         
    data: function() {
      return {
        valid: true,
        error: false,
        loading: false,
        justify: 'center',
        alignment: 'center',
      };
    },
    computed: {

    },
    mounted() {

    },
    methods: {
      activarCuenta() 
      {
        this.loading = true;
        let postPaquete = axios.post('Password/activar_cuenta', {'cadena_encriptada': this.$route.query.parametros})
        return postPaquete.then((callback) => 
        {
          if(callback.status == 200)
          {
            this.$router.push({ "name": "login"});
            this.$store.dispatch('SHOW_ERROR', {show: true, type: 'success', text: 'Cuenta activada, puede iniciar sesión.' });
          } else {
            this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: 'Hubo un error en el proceso, favor volver intentar.' });
          }
          this.loading = false;
        }).catch((error) => {
          this.loading = false;
          console.log(error.response.data);
          this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: 'Hubo un error en el proceso, favor intentar más tarde' });
        });
      },
    },
  };
</script>